import 'core-js';

import { ReactKeycloakProvider } from '@react-keycloak/web';
import React from 'react';
import ReactDOM from 'react-dom';
import ReactGA from 'react-ga4';

import { QueryCache, QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

import keycloak from './keycloak';
import * as serviceWorker from './serviceWorker';
import App from './views/App';
import LoadingComponent from './components/Loading';
import toastify from './rebranding/lib/toastify';

import { datadogRum } from '@datadog/browser-rum';

datadogRum.init({
  applicationId: process.env.REACT_APP_DG_APP_ID,
  clientToken: process.env.REACT_APP_DG_CLIENT_TOKEN,
  site: process.env.REACT_APP_DG_SITE,
  service: process.env.REACT_APP_DG_SERVICE_NAME,
  env: process.env.REACT_APP_DG_ENV,
  version: process.env.REACT_APP_VERSION,
  sessionSampleRate: 100,
  sessionReplaySampleRate: 20,
  trackUserInteractions: true,
  trackResources: true,
  trackLongTasks: true,
  defaultPrivacyLevel: 'mask-user-input'
});

ReactGA.initialize('GTM-XMVH');

const keycloakProviderInitConfig = {
  onLoad: 'check-sso',
  checkLoginIframe: false,
  enableLogging: true
};

const onKeycloakEvent = event => {
  if (event == 'onAuthSuccess' || event === 'onAuthRefreshSuccess') {
    sessionStorage.setItem('token', keycloak.token);
  }
};

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 60 * 60,
      refetchOnWindowFocus: false,
      refetchInterval: 1000 * 60 * 60,
      retry: false
    }
  },
  queryCache: new QueryCache({
    onError: (error, query) => {
      if (query?.meta?.errorMessage) {
        toastify.error(query.meta.errorMessage, 'por favor tente novamente mais tarde');
      }
    }
  })
});

//eslint-disable-next-line
ReactDOM.render(
  <QueryClientProvider client={queryClient}>
    <ReactKeycloakProvider
      authClient={keycloak}
      initOptions={keycloakProviderInitConfig}
      onEvent={onKeycloakEvent}
      LoadingComponent={<LoadingComponent />}
    >
      <App />
    </ReactKeycloakProvider>
    <ReactQueryDevtools initialIsOpen={false} />
  </QueryClientProvider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
